export default "/images/vendor/flag-icon-css/flags/1x1/vn.svg?bf6f9b0191659c38159deced45dcb8e4";